import { NAME as namespace } from './constants';
import { digitalEditReducer as reducer } from './reducer';
export var digitalEditing = {
  namespace: namespace,
  reducer: reducer
};
export default digitalEditing;